import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { Create, SimpleForm, Toolbar, TopToolbar } from "react-admin";
import setFieldData from "final-form-set-field-data";

import { BackButton } from "../../../components/common/BackButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { HelpButton } from "../../../components/common/HelpButton";
import { ProductCreateHelp } from "./ProductHelp";
import { ProductForm } from "./ProductForm";
import { ValidateCreateButton } from "./ValidateCreateButton";
import { getBackPath } from "../../../utils/utils";

const CreateActions = ({ backPath, savedRecord, ...props }) => (
  <TopToolbar>
    <HelpButton>
      <ProductCreateHelp {...props} />
    </HelpButton>
    <BackButton {...props} backPath={backPath} state={{ savedRecord }} />
  </TopToolbar>
);

const CreateToolbar = ({ backPath, savedRecord, ...props }) => (
  <Toolbar>
    <ValidateCreateButton
      {...props}
      backPath={backPath}
      savedRecord={savedRecord}
    />
  </Toolbar>
);

export const ProductCreate = (props) => {
  const history = useHistory();
  const [account] = useState(props.location?.state?.account);
  const cloneRecord = props.location?.state?.clone || {};
  const backPath = getBackPath(props);
  const savedRecord = props.location?.state?.savedRecord;
  const initValues = {
    ...cloneRecord,
    id: undefined,
    // productCode: copy productCode from parent - check unicity on save
    accountId: account ? account.id : cloneRecord.accountId,
  };

  return (
    <Create
      {...props}
      title={<ForceTitle title="New Product" />}
      actions={
        <CreateActions
          backPath={backPath}
          savedRecord={savedRecord}
          history={history}
        />
      }
    >
      <SimpleForm
        variant="outlined"
        initialValues={initValues}
        mutators={{ setFieldData }}
        toolbar={
          <CreateToolbar
            {...props}
            backPath={backPath}
            savedRecord={savedRecord}
            history={history}
            account={account}
          />
        }
      >
        <ProductForm account={account} />
      </SimpleForm>
    </Create>
  );
};
